var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"btn btn-primary",attrs:{"to":{name: this.link}}},[_c('i',{staticClass:"fas fa-plus mr-2"}),_vm._v(" "+_vm._s(_vm.text)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }